"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.places = void 0;
var env_1 = require("../../env");
exports.places = {
  id: 'places',
  label: 'Places',
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:places'] : null,
  children: [{
    id: 'cities',
    type: 'list',
    entityTypeName: 'Location',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:cities'] : null
  }, {
    id: 'countries',
    type: 'list',
    entityTypeName: 'Economy',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:countries'] : null
  }, {
    id: 'global-regions',
    type: 'list',
    entityTypeName: 'GlobalRegion',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:global-regions'] : null
  }, {
    id: 'locations',
    type: 'list',
    entityTypeName: 'Place',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:locations'] : null
  }, {
    id: 'regions',
    type: 'list',
    entityTypeName: 'Region',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:regions'] : null
  }
  // todo - add Regions (do this once mongo is in place?)
  // {
  //   id: 'states',
  //   type: 'list',
  //   entityTypeName: 'State',
  // },
  ]
};